function addScrollAnimation() {
    const image = document.querySelector('.tee-gallery-content');
    const wrapper = document.querySelector('.tee-gallery-wrapper');
    if (!image || !wrapper) return;

    let ticking = false;
    let cachedHeight = image.offsetHeight || 500;

    const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
            const newHeight = image.offsetHeight;
            
            if (newHeight > 100 && Math.abs(cachedHeight - newHeight) > 5) {
                cachedHeight = newHeight;
                window.dispatchEvent(new Event('scroll'));
            }
        }
    });
    resizeObserver.observe(image);

    window.addEventListener('scroll', () => {
        if (window.innerWidth < 768) {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollY = Math.max(0, window.scrollY);
                    
                    const startScroll = 20;  
                    const endScroll = 200;   
                    const minScale = 0.7; 

                    let scaleValue = 1;

                    if (scrollY <= startScroll) {
                        document.body.classList.remove('tee-gallery--is-sticky', 'tee-gallery--animating', 'tee-gallery-sticky');
                        scaleValue = 1;
                        
                        wrapper.style.height = ''; 
                    } else if (scrollY > startScroll && scrollY < endScroll) {
                        document.body.classList.add('tee-gallery--is-sticky', 'tee-gallery--animating');
                        document.body.classList.remove('tee-gallery-sticky');
                        
                        const t = (scrollY - startScroll) / (endScroll - startScroll);
                        scaleValue = 1 - t * (1 - minScale);
                    } else {
                        document.body.classList.add('tee-gallery--is-sticky', 'tee-gallery-sticky');
                        document.body.classList.remove('tee-gallery--animating');
                        scaleValue = minScale;
                    }
                    
                    scaleValue = Number(scaleValue.toFixed(3));
                    
                    image.style.transform = `scale(${scaleValue})`;
                    image.style.marginBottom = '0px'; 
                    
                    if (scrollY > startScroll) {
                        const currentHeight = Math.round(cachedHeight * scaleValue) + 10; // +10px padding đệm
                        wrapper.style.height = `${currentHeight}px`;
                    }
                    
                    ticking = false;
                });
                ticking = true;
            }
        } else {
            image.style.transform = 'none';
            wrapper.style.height = '';
            document.body.classList.remove('tee-gallery--is-sticky', 'tee-gallery--animating', 'tee-gallery-sticky');
        }
    }, { passive: true });

    window.dispatchEvent(new Event('scroll'));
}

function fixedLivePreview() {
    const style = document.createElement("style");
    style.innerHTML = `
        @media only screen and (max-width: 768px) {
            body.teeinblue-enabled {
                overflow-anchor: none !important;
            }

            body:not(.sticky-is--active) header#shopify-section-header-inline {
                position: static !important;
                transform: none !important;
                transition: none !important;
                animation: none !important;
            }

            .teeinblue-enabled .t4s-product__media-wrapper {
                width: 100%;
                max-width: 100vw;
                position: relative; 
                margin-left: 0;
                background: #ffffff;
                padding-bottom: 10px;
                transition: background .3s ease-in-out, box-shadow .3s ease-in-out;
            }

            .teeinblue-enabled.tee-gallery--is-sticky .t4s-product__media-wrapper {
                position: sticky;
                top: 0 !important;
                z-index: 999;
            }

            .teeinblue-enabled.tee-gallery-sticky .t4s-product__media-wrapper {
                background: #ffffff;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
            }
        
            .teeinblue-enabled .t4s-product__media-wrapper #tee-gallery {
                height: auto !important;
                margin: 0 auto;
                max-width: 100%;
                transition: none !important; 
                transform-origin: top center;
                will-change: transform, margin-bottom; 
                transform: translateZ(0); 
            }
            
            .teeinblue-item.teeinblue-item--product {
                z-index: 999999;
            }

            .teeinblue-enabled.tee-gallery-sticky .tee-thumbnails {
               display: none !important;
            }
        }
    `;
    document.head.appendChild(style);

    addScrollAnimation();
}

document.addEventListener("DOMContentLoaded", () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (h / w > 1.5 && w < 768) {
        const observer = new MutationObserver((mutations, obs) => {
            const image = document.querySelector('.tee-gallery-content');
            const wrapper = document.querySelector('.tee-gallery-wrapper');
            
            if (image && wrapper) {
                fixedLivePreview();
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});